import axios from 'axios';
import { GlobalStore } from '@/store';

// The code below is required for using devServer proxy in vue.config.js
const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'local' ? process.env.BASE_URL : '',
});
instance.defaults.withCredentials = true;
console.log('process.env.NODE_ENV', process.env.NODE_ENV);

// Request interceptor
instance.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        config.headers['withCredentials'] = true;
        console.log('AXIOS HEADER ', config);

        return config;
    },
    // Request error
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

// Response interceptor
instance.interceptors.response.use(
    function (response) {
        console.log('::: response :::', response);
        // Any status code that lie within the range of 2XX(Success) cause this function to trigger
        // http status: 200(OK), 201(Created), 202(Accepted), 204(No Content)
        console.log('::: Server Response for Client Request :::');
        console.log('::: HTTP Status Code = 2xx(Success) :::');
        return response;
    },
    // Response error
    function (error) {
        // if (error.response && error.response.status) {
        //     const dStore = DialogStore();
        //     switch (error.response.status) {
        //         // status code가 401인 경우 `/login` 페이지로 리다이렉트
        //         case 401:
        //             useDialogStore().openAlertDialog({
        //                 title: error.response.data.message,
        //                 callback: () => {
        //                     window.location.href = '/login';
        //                 },
        //             });
        //             // 이행되지 않는 Promise를 반환하여 Promise Chaining 끊어주기
        //             return new Promise(() => {});
        //         // status code가 401인 경우 `/login` 페이지로 리다이렉트
        //         case 400:
        //             dStore.openMsg(error.response.data.message);

        //             // 이행되지 않는 Promise를 반환하여 Promise Chaining 끊어주기
        //             return new Promise(() => {});
        //         default:
        //             return Promise.reject(error);
        //     }
        // }
        return Promise.reject(error);
    },
);

export default instance;
